<template>
  <v-card tile>
    <v-card-title>
      <v-row>
        <v-col cols="12" class="d-flex justify-space-between">
          <span>Dodaj transakcijo</span>
          <v-btn icon @click="save">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <v-form>
            <v-autocomplete
              v-model="money.money_type_id"
              :items="moneyTypes"
              :search-input.sync="moneyTypesSearch"
              @click="loadMoneyTypes"
              item-text="name"
              item-value="id"
              label="Tip"
            ></v-autocomplete>
            <v-text-field label="Vrednost" v-model="money.value"></v-text-field>
            <v-textarea
              label="Zapiski"
              v-model="money.notes"
              outlined
            ></v-textarea>
            <v-autocomplete
              v-model="money.vehicle_id"
              :items="vehicles"
              :search-input.sync="vehicleSearch"
              item-text="registration_plate"
              item-value="id"
              label="Vozilo"
            ></v-autocomplete>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      money: {},
      moneyTypes: [],
      moneyTypesSearch: "",
      vehicles: [],
      vehicleSearch: "",
    }),
    methods: {
      loadMoneyTypes() {
        this.$http.get("api/v1/money-types").then((response) => {
          this.moneyTypes = response.data;
        });
      },
      loadVehicles() {
        this.$http
          .get("api/v1/vehicles", {
            params: {
              filters: {
                registration_plate: encodeURI("%" + this.vehicleSearch + "%"),
              },
            },
          })
          .then((response) => {
            this.vehicles = response.data.data;
          });
      },
      save() {
        /* eslint-disable no-console */
        console.log(this.$route.params.employeeId);
        this.$http
          .post("api/v1/money", {
            ...this.money,
            employee_id: this.$route.params.employeeId,
          })
          .then((response) => {
            this.$router.push({
              name: "EmployeeMoney",
              params: { employee_id: response.data.employee_id },
            });
          });
      },
    },
    watch: {
      vehicleSearch() {
        this.loadVehicles();
      },
    },
  };
</script>
<style></style>
